const checkAllAcceptances = document.querySelector('#checkAllAcceptances');
if (checkAllAcceptances) {
    const allAcceptancesContainer = document.querySelector('.form-acceptances-list');

    checkAllAcceptances.addEventListener('change', (e) => {
        const checkboxes = allAcceptancesContainer.querySelectorAll('input');
        checkboxes.forEach(check => {
            if (checkAllAcceptances.checked === true) {
                check.checked = true;
            }

            if (checkAllAcceptances.checked === false) {
                check.checked = false;
            }
        });
    });
}

function redirectThanksPage() {
    const languageCode = document.documentElement.lang;
    const currentUrl = window.location.pathname;
    const bodyClassList = document.body.classList;
    
        if (bodyClassList.contains('page-template-homepage')) {
            if(languageCode === "en-GB") {
                window.location.href = "/thanks?homepage";
            }
            else {
                window.location.href = "/dziekujemy?strona_glowna";
            }
            
        } 
        else if (bodyClassList.contains('page-template-apartments')) {
            if(languageCode === "en-GB") {
                window.location.href = "/thanks?flat";
            }
            else {
                window.location.href = "/dziekujemy?apartamenty";
            }
            
        } 
        else if (currentUrl === '/kontakt/') {
            window.location.href = "/dziekujemy?kontakt";
        } 
        else if (currentUrl === '/en/contact/') {
            window.location.href = "/thanks?contact";
        } 
        else {
            window.location.href = "/dziekujemy/";
        }
}

const wpcf7Elm = document.querySelector('.wpcf7-form');
if (wpcf7Elm) {
    wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-11073847359');

        redirectThanksPage();
    }, false);
}